import _sortBy from 'lodash.sortby';
import { WorkflowGraph } from 'cio/utils/visual-workflow-builder/workflow-graph';

function findFirstNodeId(workflowGraph: WorkflowGraph) {
  return Object.keys(workflowGraph.nodes).find((nodeId) => workflowGraph.inEdges[nodeId].length === 0);
}

export function rank(workflowGraph: WorkflowGraph) {
  let ranks: Record<string, number> = {};
  let traversalOrder: string[] = [];
  let traversedNodeIds: Record<string, boolean> = {};
  let layeredRanks: Record<number, string[]> = {};

  let nodesToTraverse: { id: string; depth: number }[] = [];

  let startNodeId = findFirstNodeId(workflowGraph);
  if (startNodeId) {
    nodesToTraverse.push({ id: startNodeId, depth: 0 });
  }

  while (nodesToTraverse.length > 0) {
    let node = nodesToTraverse.shift();

    if (!node) {
      continue;
    }

    let { id: nodeId, depth } = node;

    let currentRank = ranks[nodeId];

    // If the rank exists and is the same as the depth, AND the node exists in
    // the traversal order, skip this iteration.
    // This means that this node has been reached through an equivalent path
    // already and we don't need to traverse more from this point.
    if (currentRank === depth && traversedNodeIds[nodeId]) {
      continue;
    }

    if (!layeredRanks[depth]) {
      layeredRanks[depth] = [];
    }

    if (currentRank == null) {
      traversalOrder.push(nodeId);
      traversedNodeIds[nodeId] = true;
      ranks[nodeId] = depth;
      layeredRanks[depth].push(nodeId);
    }

    if (currentRank < depth) {
      ranks[nodeId] = depth;
      layeredRanks[depth].push(nodeId);
    }

    let outgoingEdges = workflowGraph.outEdges[nodeId] ?? [];
    if (outgoingEdges.length > 1) {
      outgoingEdges = _sortBy(outgoingEdges, ['index']);
    }

    let nextNodes = outgoingEdges.mapBy('to');

    nextNodes.forEach((n) => {
      let currentRank = ranks[nodeId];
      if (currentRank == null) {
        nodesToTraverse.push({ id: n, depth: depth + 1 });
      } else if (currentRank < depth + 1) {
        nodesToTraverse.push({ id: n, depth: depth + 1 });
      }
    });
  }

  workflowGraph.ranks = ranks;
  workflowGraph.traversalOrder = traversalOrder;
  workflowGraph.layeredRanks = layeredRanks;
}
